module.exports = __webpack_public_path__ + "static/media/baja.298102d4.ogg";